import { z } from 'zod';

export const CateringEventFormatModelSchema = z.object({
    uid: z.string(),
    name: z.string(),
    description: z.any().optional(),
    image: z.object({
        url: z.string(),
    }).optional().nullable(),
    category: z.object({
        uid: z.string(),
        name: z.string(),
        slug: z.string(),
    }).optional().nullable(),
    slug: z.string(),
});

export type CateringEventFormatModel = z.infer<typeof CateringEventFormatModelSchema>;
